// Shared constants for navigation behavior.
export const DESKTOP_QUERY = "(min-width: 961px)";
